import React from "react";
import { useParams } from "react-router-dom";
import blogs from "./BlogsSectionDetails";

const BlogDetails = () => {
    const { slug } = useParams();
    const blog = blogs.find((b) => b.slug === slug);

    if (!blog) {
        return (
            <div className="container min-vh-100 d-flex align-items-center justify-content-center">
                <h1 className="text-center text-muted">Blog not found</h1>
            </div>
        );
    }

    return (
        <div className="py-4 py-md-5">
            <div className="row justify-content-center">
                <div className="col-12 col-md-10 col-lg-8">
                    {/* Title section */}
                    {/* <h1 className="mb-4 text-center text-md-start">{blog.title}</h1> */}

                    {/* Image section */}
                    <div className="mb-4">
                        <img
                            src={blog.image}
                            alt={blog.title}
                            className="img-fluid w-100 shadow"
                            style={{
                                borderRadius: "8px",
                                objectFit: "cover",
                                maxHeight: "500px"
                            }}
                        />
                    </div>

                    {/* Content section */}
                    <div className="blog-content">
                        <div
                            className="prose"
                            dangerouslySetInnerHTML={{ __html: blog.content }}
                        />
                    </div>
                </div>
            </div>
        </div>
    );
};

export default BlogDetails;